import React, { useState } from "react";
import {
  Drawer,
  Tab,
  Tabs,
  Divider,
  Fab,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Message as MessageIcon } from "@material-ui/icons";
import DotMenu from "./DotMenu";
import { firebaseConfig as firebase } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import {Chatfeed} from "./Chat";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
// import { Conversation, Avatar } from "@chatscope/chat-ui-kit-react";
import MessageBar from "./MessageBar";
import { EmojipickerProvider } from "../contexts/EmojiPickerContext";
import { AddChatDialog } from "./AddChatDialog";
import { useAddChatDialog } from "../contexts/AddChatDialogContext";
import Branding from "./Branding";
import ChatListItems from "./ChatListItems";
import NoChatBanner from "./NoChatBanner";

const drawerWidth = 300;

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    // padding: theme.spacing(3),
  },
  fabButton: {
    position: "fixed",
    zIndex: 1,
    top: "auto",
    bottom: 10,
    left: "220px",
    right: "auto",
    // margin: '0 auto',
  },
}));

export const TabPanel = (props) => {
  const { children, value, index, tabKey, ...other } = props;
  return (
    <div
      key={tabKey}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const db = firebase.firestore();

function DesktopHome() {
  const { currentUser } = useAuth();
  const [chats, setChatList] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const { dialogOpen, setDialogOpen } = useAddChatDialog();
  const classes = useStyle();

  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchChats = () => {
    const unsubscribe = db
      .collection("rooms")
      .where("participents", "array-contains", currentUser.uid)
      .onSnapshot((querySnapshot) => {
        const chats = [];
        querySnapshot.forEach((doc) => {
          chats.push(doc.data());
          // console.log(doc.ref);
        });
        setChatList(chats);
      });

    if (!currentUser) unsubscribe();
  };

  React.useEffect(() => {
    fetchChats();
  }, []);

  return (
    <div className={classes.root}>
      <Drawer
        className={classes.drawer}
        variant={isMobileDevice ? "temporary" : "permanent"}
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <Branding >
          <DotMenu />
        </Branding>
        <Divider />
        {(chats === []) ? (
          <NoChatBanner />
        ) : (
          <Tabs
          value={tabValue}
          orientation="vertical"
          variant="scrollable"
          className={classes.tabs}
          onChange={(event, newValue) => {
            setTabValue(newValue);
          }}
        >
          {chats.map((chat, index) => (
            <Tab
              style={{ margin: "1px", padding: "0px" }}
              key={index}
              label={
                <ChatListItems tab={true} key={index} chat={chat} />
              }
            />
          ))}
        </Tabs>
        )}
        <div className={classes.fabButton}>
          <Fab
            aria-describedby="chat-popover"
            onClick={(e) => setDialogOpen(true)}
            size="medium"
            color="secondary"
            aria-label="add"
          >
            <MessageIcon />
          </Fab>
        </div>
        <AddChatDialog open={dialogOpen} />
      </Drawer>
      <div className={classes.content}>
        {chats.map((chat, index) => (
          <TabPanel tabKey={index} value={tabValue} index={index}>
            <Chatfeed chatData={chat} />
            <EmojipickerProvider>
              <MessageBar roomID={chat.roomID} />
            </EmojipickerProvider>
          </TabPanel>
        ))}
      </div>
    </div>
  );
}

export default DesktopHome;
